import { Typography, Box, useTheme } from "@mui/material";
import { tokens } from "../theme";

const Topbar = ({ title, subtitle }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box mb="10px">
      <Typography
        variant="h3"
        color={colors.grey[100]}
        fontWeight="bold"
        sx={{ m: "0 0 5px 0" }}
      >
        {title}
      </Typography>
      <Typography variant="h6" color="#0b6885">
        {subtitle}
      </Typography>
    </Box>
  );
};

export default Topbar;
